import hexToRgb from "./hexToRgb";

function rgba(color, opacity) {  
  const colorValue= hexToRgb(color);
  const matches = colorValue.match(/\d+/g);
  const r = matches ? matches[0] || 0 : 0;
  const g = matches ? matches[1] || 0 : 0;
  const b = matches ? matches[2] || 0 : 0;
  const rgbaColor = `rgba(${r}, ${g}, ${b}, ${opacity})`; 
  return rgbaColor;
}
export default rgba;
 